/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uploader-dialog.vue?vue&type=template&id=49f8124d&"
import script from "./uploader-dialog.vue?vue&type=script&lang=ts&"
export * from "./uploader-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./uploader-dialog.vue?vue&type=style&index=0&id=49f8124d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports